import './index.scss';
import classnames from 'classnames';
import { func, string } from 'prop-types';
import React, { useState } from 'react';
import { debounce } from 'throttle-debounce';
const GeniusSearch = (props) => {
    GeniusSearch.propTypes = {
        customClassName: string,
        handleSearch: func.isRequired,
        id: string.isRequired,
        placeholder: string,
        searchText: string,
        setSearchText: func.isRequired,
    };
    const [debounceUpdateSearch] = useState(() => debounce(500, false, value => {
        props.handleSearch(value);
    }));
    const search = value => {
        props.setSearchText(value);
        debounceUpdateSearch(value);
    };
    const classes = classnames('search-container', { [props.customClassName]: props.customClassName });
    return (React.createElement("div", { id: props.id, className: classes },
        React.createElement("div", { className: 'search-icon-container' },
            React.createElement("span", { className: 'fas fa-search search-icon' })),
        React.createElement("input", { placeholder: props.placeholder || 'search...', className: 'remove-focus-highlight search-box', onChange: e => search(e.target.value), value: props.searchText, rows: 1, type: 'text' })));
};
export default GeniusSearch;
